// extracted by mini-css-extract-plugin
export default {"quote__image":"Quote_quote__image__mzk6o","quote__text":"Quote_quote__text__8tSuD","quote__caption":"Quote_quote__caption__pJibt"};